import React from 'react'
import PropTypes from 'prop-types'
import { ToggleButton } from '../styles'

export const DefaultToggleOption = ({ value, children, disabled, selected, size, onClick }) => {
  return (
    <ToggleButton
      $selected={selected}
      $size={size}
      disabled={disabled}
      onClick={() => { if (!disabled) onClick(value) }}
    >
      {children}
    </ToggleButton>
  )
}

DefaultToggleOption.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  onClick: PropTypes.func,
}

DefaultToggleOption.defaultProps = {
  size: 'medium',
}
